import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';
// Fixed import issue

const CategorySpecificBooking = ({ ticket, onBookingDataChange, visitDate, initialData = {} }) => {
  const [categoryData, setCategoryData] = useState(initialData);
  const [availability, setAvailability] = useState(null);
  const [checkingAvailability, setCheckingAvailability] = useState(false);

  const handleDataChange = (key, value) => {
    const newData = { ...categoryData, [key]: value };
    setCategoryData(newData);
    onBookingDataChange(newData);
  };



  const checkAvailability = async () => {
    if (!visitDate || ticket.category !== 'function_hall_ticket') return;
    
    setCheckingAvailability(true);
    try {
      const response = await fetch(`/api/availability/function-hall/${ticket._id}/${visitDate}`);
      const data = await response.json();
      setAvailability(data);
    } catch (error) {
      console.error('Error checking availability:', error);
    } finally {
      setCheckingAvailability(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (visitDate && ticket.category === 'function_hall_ticket') {
      checkAvailability();
    }
  }, [visitDate, ticket._id]);
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (Object.keys(initialData).length > 0) {
      const dataWithDocuments = {
        ...initialData,
        passportPhoto: initialData.passportPhoto || initialData.documents?.passportPhoto,
        idProof: initialData.idProof || initialData.documents?.idProof
      };
      setCategoryData(dataWithDocuments);
      onBookingDataChange(dataWithDocuments);
    }
  }, [initialData]);

  const renderCategoryFields = () => {
    switch (ticket.category) {
      case 'parking_ticket':
        const availableParkingTypes = ticket.parkingSettings ? 
          Object.entries(ticket.parkingSettings).filter(([_, config]) => config.enabled) : [];
        
        const defaultVehicleTypes = [
          { type: 'car', icon: '🚗', name: 'Car', price: ticket.price || 50, duration: 24 },
          { type: 'motorcycle', icon: '🏍️', name: 'Motorcycle', price: Math.round((ticket.price || 50) * 0.5), duration: 24 },
          { type: 'bus', icon: '🚌', name: 'Bus', price: Math.round((ticket.price || 50) * 3), duration: 24 },
          { type: 'truck', icon: '🚛', name: 'Truck', price: Math.round((ticket.price || 50) * 2.5), duration: 24 }
        ];
        
        const vehicleOptions = availableParkingTypes.length > 0 ? 
          availableParkingTypes.map(([type, config]) => ({
            type,
            icon: defaultVehicleTypes.find(v => v.type === type)?.icon || '🚗',
            name: type.charAt(0).toUpperCase() + type.slice(1),
            price: config.price,
            duration: config.duration
          })) : defaultVehicleTypes;
        
        // Update total amount when vehicle type changes
        const selectedVehicle = vehicleOptions.find(v => v.type === categoryData.vehicleType);
        if (selectedVehicle && categoryData.totalAmount !== selectedVehicle.price) {
          handleDataChange('totalAmount', selectedVehicle.price);
        }
        
        return (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🅿️ Select Vehicle Type
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginBottom: '16px' }}>
              {vehicleOptions.map((vehicle) => (
                <div
                  key={vehicle.type}
                  onClick={() => handleDataChange('vehicleType', vehicle.type)}
                  style={{
                    background: categoryData.vehicleType === vehicle.type ? '#3b82f6' : 'white',
                    color: categoryData.vehicleType === vehicle.type ? 'white' : '#2d3748',
                    border: `2px solid ${categoryData.vehicleType === vehicle.type ? '#3b82f6' : '#e2e8f0'}`,
                    borderRadius: '8px',
                    padding: '16px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <div style={{ fontSize: '24px', marginBottom: '8px' }}>{vehicle.icon}</div>
                  <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '4px' }}>{vehicle.name}</div>
                  <div style={{ fontSize: '16px', fontWeight: '700', color: categoryData.vehicleType === vehicle.type ? 'white' : '#3b82f6' }}>₹{vehicle.price}</div>
                  <div style={{ fontSize: '12px', opacity: 0.8 }}>{vehicle.duration}h</div>
                </div>
              ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                  Vehicle Number
                </label>
                <input
                  type="text"
                  value={categoryData.vehicleNumber || ''}
                  onChange={(e) => handleDataChange('vehicleNumber', e.target.value)}
                  placeholder="e.g., OD-05-1234"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
          </div>
        );

      case 'chappal_stand_ticket':
        return (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
              👟 Chappal Stand Service
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                  Number of Pairs
                </label>
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={categoryData.pairCount || 1}
                  onChange={(e) => handleDataChange('pairCount', parseInt(e.target.value))}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                  Special Instructions
                </label>
                <input
                  type="text"
                  value={categoryData.instructions || ''}
                  onChange={(e) => handleDataChange('instructions', e.target.value)}
                  placeholder="Any special care needed"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
          </div>
        );

      case 'puja_ticket':
        const availablePujaServices = ticket.pujaServices ? 
          Object.entries(ticket.pujaServices).filter(([_, config]) => config.enabled) : [];
        
        const selectedServices = categoryData.selectedServices || {};
        const totalAmount = Object.entries(selectedServices)
          .filter(([_, quantity]) => quantity > 0)
          .reduce((sum, [serviceName, quantity]) => {
            const service = availablePujaServices.find(([name]) => name === serviceName);
            return sum + (service ? service[1].price * quantity : 0);
          }, 0);
        
        // Update total amount in category data
        if (totalAmount !== categoryData.totalAmount) {
          handleDataChange('totalAmount', totalAmount);
        }
        
        if (availablePujaServices.length === 0) {
          return (
            <div style={{ marginBottom: '20px' }}>
              <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
                🙏 Puja Service Details
              </h4>
              <div style={{
                background: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '8px',
                padding: '16px',
                textAlign: 'center'
              }}>
                <div style={{ color: '#dc2626', fontWeight: '600', marginBottom: '8px' }}>
                  No Puja Services Configured
                </div>
                <div style={{ color: '#6b7280', fontSize: '14px' }}>
                  Please contact the temple administration to configure puja services.
                </div>
              </div>
            </div>
          );
        }
        
        return (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🙏 Select Puja Services
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px', marginBottom: '16px' }}>
              {availablePujaServices.map(([serviceName, config]) => (
                <div key={serviceName} style={{
                  background: 'white',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  padding: '16px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <span style={{ fontWeight: '600', color: '#2d3748' }}>{serviceName}</span>
                    <span style={{ color: '#3b82f6', fontWeight: '600' }}>₹{config.price}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <button
                      type="button"
                      onClick={() => {
                        const currentQty = selectedServices[serviceName] || 0;
                        const newQty = Math.max(0, currentQty - 1);
                        handleDataChange('selectedServices', {
                          ...selectedServices,
                          [serviceName]: newQty
                        });
                      }}
                      style={{
                        background: '#ef4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        width: '30px',
                        height: '30px',
                        cursor: 'pointer'
                      }}
                    >
                      -
                    </button>
                    <span style={{ minWidth: '30px', textAlign: 'center', fontWeight: '600' }}>
                      {selectedServices[serviceName] || 0}
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        const currentQty = selectedServices[serviceName] || 0;
                        const newQty = currentQty + 1;
                        handleDataChange('selectedServices', {
                          ...selectedServices,
                          [serviceName]: newQty
                        });
                      }}
                      style={{
                        background: '#10b981',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        width: '30px',
                        height: '30px',
                        cursor: 'pointer'
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>
            {totalAmount > 0 && (
              <div style={{
                background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
                color: 'white',
                padding: '16px',
                borderRadius: '8px',
                textAlign: 'center',
                marginBottom: '16px'
              }}>
                <div style={{ fontSize: '18px', fontWeight: '700' }}>Total: ₹{totalAmount}</div>
                <div style={{ fontSize: '12px', opacity: 0.9 }}>Selected Services Total</div>
              </div>
            )}
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                Preferred Time
              </label>
              <select
                value={categoryData.preferredTime || ''}
                onChange={(e) => handleDataChange('preferredTime', e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none'
                }}
              >
                <option value="">Any Time</option>
                <option value="morning">🌅 Morning (6-10 AM)</option>
                <option value="afternoon">☀️ Afternoon (12-4 PM)</option>
                <option value="evening">🌅 Evening (6-8 PM)</option>
              </select>
            </div>
          </div>
        );

      case 'function_hall_ticket':
        console.log('Function hall ticket data:', ticket);
        console.log('Function hall settings:', ticket.functionHallSettings);
        const availableAmenities = ticket.functionHallSettings?.amenities ? 
          Object.entries(ticket.functionHallSettings.amenities).filter(([_, config]) => config.enabled) : [];
        console.log('Available amenities:', availableAmenities);
        
        const selectedAmenities = categoryData.selectedAmenities || {};
        const amenitiesTotal = Object.entries(selectedAmenities)
          .filter(([_, isSelected]) => isSelected)
          .reduce((sum, [amenityName]) => {
            const amenity = availableAmenities.find(([name]) => name === amenityName);
            return sum + (amenity ? amenity[1].price : 0);
          }, 0);
        
        const hallTotalAmount = ticket.price + amenitiesTotal;
        
        if (hallTotalAmount !== categoryData.totalAmount) {
          handleDataChange('totalAmount', hallTotalAmount);
        }
        
        return (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🎉 Function Hall Booking
            </h4>
            
            {/* Availability Status */}
            {visitDate && (
              <div style={{
                background: checkingAvailability ? '#f0f9ff' : 
                          availability?.available ? '#f0fdf4' : '#fef2f2',
                border: `1px solid ${checkingAvailability ? '#bae6fd' : 
                                    availability?.available ? '#bbf7d0' : '#fecaca'}`,
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '16px'
              }}>
                <div style={{ 
                  fontSize: '14px', 
                  fontWeight: '600',
                  color: checkingAvailability ? '#0369a1' : 
                        availability?.available ? '#15803d' : '#dc2626'
                }}>
                  {checkingAvailability ? '🔄 Checking availability...' :
                   availability?.available ? '✅ Hall is available for this date' :
                   '❌ Hall is already booked for this date'}
                </div>
                {availability && !availability.available && (
                  <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                    Please select a different date
                  </div>
                )}
              </div>
            )}
            
            {/* Hall Details */}
            <div style={{
              background: '#f0f9ff',
              border: '1px solid #bae6fd',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '12px', fontSize: '14px' }}>
                <div><strong>Capacity:</strong> {ticket.functionHallSettings?.hallCapacity || 100} people</div>
                <div><strong>Duration:</strong> {ticket.functionHallSettings?.duration || 4} hours</div>
                <div><strong>Base Price:</strong> ₹{ticket.price}</div>
              </div>
            </div>
            
            {/* Amenities Selection */}
            {availableAmenities.length > 0 && (
              <>
                <h5 style={{ margin: '0 0 12px 0', color: '#2d3748' }}>🛠️ Additional Services</h5>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px', marginBottom: '16px' }}>
                  {availableAmenities.map(([amenityName, config]) => {
                    const isSelected = selectedAmenities[amenityName] || false;
                    return (
                      <label key={amenityName} style={{
                        background: isSelected ? '#f0f9ff' : 'white',
                        border: `2px solid ${isSelected ? '#3b82f6' : '#e2e8f0'}`,
                        borderRadius: '12px',
                        padding: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                      }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={(e) => {
                            handleDataChange('selectedAmenities', {
                              ...selectedAmenities,
                              [amenityName]: e.target.checked
                            });
                          }}
                          style={{
                            width: '18px',
                            height: '18px',
                            accentColor: '#3b82f6'
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <h6 style={{ 
                            margin: '0 0 4px 0', 
                            fontWeight: '700', 
                            color: '#2d3748', 
                            textTransform: 'capitalize',
                            fontSize: '14px'
                          }}>
                            {amenityName.replace(/_/g, ' ')}
                          </h6>
                          <div style={{ 
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#3b82f6'
                          }}>
                            ₹{config.price}
                          </div>
                        </div>
                      </label>
                    );
                  })}
                </div>
              </>
            )}
            
            {/* Total Display */}
            {amenitiesTotal > 0 && (
              <div style={{
                background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
                color: 'white',
                padding: '16px',
                borderRadius: '8px',
                marginBottom: '16px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <span>Hall Booking:</span>
                  <span>₹{ticket.price}</span>
                </div>
                {Object.entries(selectedAmenities)
                  .filter(([_, isSelected]) => isSelected)
                  .map(([amenityName]) => {
                    const amenity = availableAmenities.find(([name]) => name === amenityName);
                    const amenityPrice = amenity ? amenity[1].price : 0;
                    return (
                      <div key={amenityName} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <span style={{ textTransform: 'capitalize' }}>{amenityName.replace(/_/g, ' ')}:</span>
                        <span>₹{amenityPrice}</span>
                      </div>
                    );
                  })
                }
                <hr style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.3)', margin: '8px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: '700' }}>
                  <span>Total:</span>
                  <span>₹{hallTotalAmount}</span>
                </div>
              </div>
            )}
            
            {/* Booking Details */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                  Event Type
                </label>
                <select
                  value={categoryData.eventType || ''}
                  onChange={(e) => handleDataChange('eventType', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                >
                  <option value="">Select Event Type</option>
                  <option value="wedding">💒 Wedding</option>
                  <option value="birthday">🎂 Birthday Party</option>
                  <option value="corporate">🏢 Corporate Event</option>
                  <option value="conference">📊 Conference</option>
                  <option value="reception">🥂 Reception</option>
                  <option value="other">🎉 Other</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                  Expected Guests
                </label>
                <input
                  type="number"
                  min="1"
                  max={ticket.functionHallSettings?.hallCapacity || 100}
                  value={categoryData.expectedGuests || ''}
                  onChange={(e) => handleDataChange('expectedGuests', parseInt(e.target.value))}
                  placeholder="Number of guests"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
            
            <div style={{ marginTop: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                Special Requirements
              </label>
              <textarea
                value={categoryData.specialRequirements || ''}
                onChange={(e) => handleDataChange('specialRequirements', e.target.value)}
                placeholder="Decoration preferences, catering needs, special arrangements..."
                rows={3}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  resize: 'vertical'
                }}
              />
            </div>
          </div>
        );

      case 'event_ticket':
        return (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🎭 Event Details
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                  Seating Preference
                </label>
                <select
                  value={categoryData.seatingPreference || ''}
                  onChange={(e) => handleDataChange('seatingPreference', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                >
                  <option value="">Any Seating</option>
                  <option value="front">🎯 Front Row</option>
                  <option value="middle">👥 Middle Section</option>
                  <option value="back">🔙 Back Section</option>
                  <option value="vip">⭐ VIP Section</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                  Special Requirements
                </label>
                <input
                  type="text"
                  value={categoryData.specialRequirements || ''}
                  onChange={(e) => handleDataChange('specialRequirements', e.target.value)}
                  placeholder="Wheelchair access, etc."
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
          </div>
        );

      case 'pass_ticket':
        return (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
              📅 Pass Ticket Details
            </h4>
            <div style={{
              background: '#f0f9ff',
              border: '1px solid #bae6fd',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '12px', fontSize: '14px' }}>
                <div><strong>Validity:</strong> {ticket.validity?.duration || 30} days</div>
                <div><strong>Pass Type:</strong> {ticket.passTicketSettings?.passType === 'limited' ? `Limited (${ticket.passTicketSettings?.visitLimit || 10} visits)` : 'Unlimited Visits'}</div>
                <div><strong>Price:</strong> ₹{ticket.price}</div>
              </div>
            </div>
            
            {/* Document Upload Section */}
            {(ticket.passTicketSettings?.requiresPhoto || ticket.passTicketSettings?.requiresIdProof) && (
              <div style={{
                background: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
              }}>
                <h5 style={{ margin: '0 0 12px 0', color: '#374151', fontSize: '16px', fontWeight: '600' }}>Required Documents</h5>
                

                {/* Show existing documents if available */}
                {(initialData.documents?.passportPhoto || initialData.passportPhoto) && (
                  <div style={{ marginBottom: '12px', padding: '12px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                      <span style={{ fontSize: '16px' }}>✅</span>
                      <span style={{ fontSize: '14px', fontWeight: '600', color: '#15803d' }}>Existing Documents Found</span>
                    </div>
                    <div style={{ display: 'flex', gap: '16px' }}>
                      {(initialData.documents?.passportPhoto || initialData.passportPhoto) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <img 
                            src={`${API_BASE_URL}${initialData.documents?.passportPhoto || initialData.passportPhoto}`} 
                            alt="Pass holder" 
                            style={{ width: '32px', height: '40px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #d1d5db' }}
                            onError={(e) => {
                              console.error('Image load error:', e.target.src);
                              console.error('Failed to load image:', {
                                src: e.target.src,
                                'initialData.documents?.passportPhoto': initialData.documents?.passportPhoto,
                                'initialData.passportPhoto': initialData.passportPhoto
                              });
                            }}
                            onLoad={() => console.log('Image loaded successfully:', `${API_BASE_URL}${initialData.documents?.passportPhoto || initialData.passportPhoto}`)}
                          />
                          <span style={{ fontSize: '12px', color: '#374151' }}>📷 Passport Photo</span>
                        </div>
                      )}
                      {(initialData.documents?.idProof || initialData.idProof) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <img 
                            src={`${API_BASE_URL}${initialData.documents?.idProof || initialData.idProof}`} 
                            alt="ID proof" 
                            style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #d1d5db' }}
                            onError={(e) => {
                              console.error('ID proof load error:', e.target.src);
                              // Fallback to icon if image fails to load
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                          <div style={{ width: '32px', height: '32px', background: '#059669', borderRadius: '4px', display: 'none', alignItems: 'center', justifyContent: 'center', fontSize: '14px', color: 'white' }}>🆔</div>
                          <span style={{ fontSize: '12px', color: '#374151' }}>ID Proof</span>
                        </div>
                      )}
                    </div>
                    <div style={{ fontSize: '12px', color: '#059669', marginTop: '8px' }}>These documents will be used for your pass renewal. Upload new ones only if you want to replace them.</div>
                    <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '4px' }}>Debug: {`${API_BASE_URL}${initialData.documents?.passportPhoto || initialData.passportPhoto}`}</div>
                  </div>
                )}
                
                {ticket.passTicketSettings?.requiresPhoto && (
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                      📷 Passport Photo *
                    </label>
                    {(initialData.documents?.passportPhoto || initialData.passportPhoto || categoryData.passportPhoto) ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px', border: '1px solid #d1d5db', borderRadius: '6px', background: '#f9fafb' }}>
                        <img 
                          src={`${API_BASE_URL}${initialData.documents?.passportPhoto || initialData.passportPhoto || categoryData.passportPhoto}`} 
                          alt="Pass holder" 
                          style={{ width: '40px', height: '48px', objectFit: 'cover', borderRadius: '4px' }}
                        />
                        <span style={{ fontSize: '14px', color: '#374151' }}>Using existing photo from previous pass</span>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const formData = new FormData();
                              formData.append('passportPhoto', file);
                              try {
                                const response = await fetch(`${API_BASE_URL}/api/upload/documents`, {
                                  method: 'POST',
                                  body: formData
                                });
                                const result = await response.json();
                                if (result.success) {
                                  handleDataChange('passportPhoto', result.documents.passportPhoto);
                                }
                              } catch (error) {
                                console.error('Upload failed:', error);
                              }
                            }
                          }}
                          required
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            fontSize: '14px'
                          }}
                        />
                        {categoryData.passportPhoto && (
                          <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <img 
                              src={`${API_BASE_URL}/${categoryData.passportPhoto}`} 
                              alt="Pass holder" 
                              style={{ width: '40px', height: '48px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #d1d5db' }}
                            />
                            <span style={{ fontSize: '12px', color: '#059669' }}>✓ Photo uploaded successfully</span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
                
                {ticket.passTicketSettings?.requiresIdProof && (
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                      🆔 ID Proof (Govt ID/School ID) *
                    </label>
                    {(initialData.documents?.idProof || initialData.idProof || categoryData.idProof) ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px', border: '1px solid #d1d5db', borderRadius: '6px', background: '#f9fafb' }}>
                        <div style={{ width: '40px', height: '32px', background: '#e5e7eb', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>🆔</div>
                        <span style={{ fontSize: '14px', color: '#374151' }}>Using existing ID proof from previous pass</span>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          accept="image/*,.pdf"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const formData = new FormData();
                              formData.append('idProof', file);
                              try {
                                const response = await fetch(`${API_BASE_URL}/api/upload/documents`, {
                                  method: 'POST',
                                  body: formData
                                });
                                const result = await response.json();
                                if (result.success) {
                                  handleDataChange('idProof', result.documents.idProof);
                                }
                              } catch (error) {
                                console.error('Upload failed:', error);
                              }
                            }
                          }}
                          required
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            fontSize: '14px'
                          }}
                        />
                        {categoryData.idProof && (
                          <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ width: '40px', height: '32px', background: '#059669', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', color: 'white' }}>🆔</div>
                            <span style={{ fontSize: '12px', color: '#059669' }}>✓ ID proof uploaded successfully</span>
                          </div>
                        )}
                        <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                          Accepted: Aadhar, PAN, Driving License, Voter ID, School ID Card
                        </p>
                      </>
                    )}
                  </div>
                )}
                
                <p style={{ fontSize: '12px', color: '#6b7280', margin: '8px 0 0 0' }}>
                  * Required documents for pass verification
                </p>
              </div>
            )}
            
            {/* Additional Information Fields */}
            {ticket.passTicketSettings?.additionalFields && ticket.passTicketSettings.additionalFields.length > 0 && (
              <div style={{ marginBottom: '16px' }}>
                <h5 style={{ margin: '0 0 12px 0', color: '#374151', fontSize: '16px', fontWeight: '600' }}>Additional Information</h5>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                  {ticket.passTicketSettings.additionalFields.map((field, index) => (
                    <div key={index}>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                        {field.fieldName} {field.isRequired && '*'}
                      </label>
                      {field.fieldType === 'select' ? (
                        <select
                          value={categoryData[`field_${index}`] || ''}
                          onChange={(e) => handleDataChange(`field_${index}`, e.target.value)}
                          required={field.isRequired}
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            fontSize: '14px'
                          }}
                        >
                          <option value="">Select...</option>
                          {(field.options || []).map((option, optIndex) => (
                            <option key={optIndex} value={option}>{option}</option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type={field.fieldType === 'phone' ? 'tel' : field.fieldType}
                          value={categoryData[`field_${index}`] || ''}
                          onChange={(e) => handleDataChange(`field_${index}`, e.target.value)}
                          required={field.isRequired}
                          placeholder={field.fieldType === 'date' ? 'YYYY-MM-DD' : `Enter ${field.fieldName.toLowerCase()}`}
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            fontSize: '14px'
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
                Special Instructions
              </label>
              <textarea
                value={categoryData.specialInstructions || ''}
                onChange={(e) => handleDataChange('specialInstructions', e.target.value)}
                placeholder="Any special terms or conditions for this pass..."
                rows={3}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  resize: 'vertical'
                }}
              />
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={{
      background: '#f8fafc',
      padding: '20px',
      borderRadius: '12px',
      border: '1px solid #e2e8f0',
      marginBottom: '20px'
    }}>
      {renderCategoryFields()}
    </div>
  );
};

export default CategorySpecificBooking;